export default __webpack_public_path__ + "41622c0bb2361a76243d137221ad95a6.png";